import { useNavigate } from 'react-router-dom';

export default function CTA() {
  const navigate = useNavigate();

  const handleEnrollClick = () => {
    navigate('/lms/course-catalog');
  };

  return (
    <section id="cta-section" className="py-20 bg-gradient-to-br from-teal-500/10 via-gray-900/50 to-cyan-500/10 backdrop-blur-sm">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden">
            <div 
              className="absolute inset-0 z-0"
              style={{
                backgroundImage: 'url(https://public.readdy.ai/ai/img_res/7c96572082df03eb1585309c681e6bc6.jpg)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 via-gray-950/90 to-teal-900/80"></div>
            </div>

            <div className="relative z-10 px-12 py-20 text-center">
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                Ready to Start Your Journey?
              </h2>
              <p className="text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed">
                Join hundreds of professionals who have transformed their careers with our expert-led training programs. Start learning today!
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-10">
                <button 
                  onClick={handleEnrollClick}
                  className="px-8 py-4 bg-teal-500 text-gray-900 rounded-lg hover:bg-teal-400 transition-all cursor-pointer whitespace-nowrap font-semibold text-lg shadow-lg shadow-teal-500/20"
                >
                  Enroll Now
                </button>
                <button className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-lg hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap font-semibold text-lg border border-white/20">
                  Schedule a Call
                </button>
              </div>

              <div className="flex flex-wrap justify-center gap-8 text-sm text-gray-400">
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-400"></i>
                  <span>No prior experience needed</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-400"></i>
                  <span>Flexible payment options</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-teal-400"></i>
                  <span>Money-back guarantee</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}